var parent = require('../../es/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/assign.js
// module id = 572
// module chunks = 0 1